import IpUtils from '../utils/IpUtils';

export const getIpAndRegion = async () => {
  const ip = await IpUtils.getIpAddress();
  const region = await IpUtils.getRegion();
  return { ip, region };
};
